export function PauseIcon () {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      className='icon pause-icon'
      aria-label='Pause'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M15.75 5.25v13.5m-7.5-13.5v13.5'
      />
    </svg>
  )
}
